import { Button } from '@raspberrypifoundation/design-system-react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import NewProjectCard from 'components/shared/NewProjectCard/NewProjectCard'

import './ProjectSuggestions.scss'

export const ProjectSuggestions = ({ project }) => {
  const { t, i18n } = useTranslation()

  return (
    <section className="c-project-suggestions">
      <div className="c-project-suggestions__text-container">
        <p className="c-project-suggestions__heading">
          {t('project.project_complete.project_suggestions.try_something_else')}
        </p>
        {project.recommendedProjects?.length > 0 && (
          <p className="c-project-suggestions__subtext">
            {t('project.project_complete.project_suggestions.you_might_like')}
          </p>
        )}
      </div>

      <div className="c-project-suggestions__cards">
        {project.recommendedProjects?.map((rec) => {
          return (
            <NewProjectCard
              key={rec.data.id}
              projectSummary={rec.data.attributes}
            />
          )
        })}
      </div>
      <Button
        text={t('project.project_complete.browse_all_projects')}
        className="c-project-suggestions__button"
        href={`/${i18n.language}/projects`}
      />
    </section>
  )
}

ProjectSuggestions.propTypes = {
  project: PropTypes.shape({
    recommendedProjects: PropTypes.arrayOf(PropTypes.object),
  }),
}

export default ProjectSuggestions

ProjectSuggestions.propTypes = {
  project: PropTypes.object.isRequired,
}
